<h1 mat-dialog-title class="text-center">
  <img *ngIf="currentUser.organization.avatar" [src]="currentUser.organization.avatar" height="50">
  <strong *ngIf="!currentUser.organization.avatar">
    ATENÇÃO!
  </strong>
</h1>
<div mat-dialog-content class="border-top border-bottom pt-3 pb-3">

  <p>
    Você está conectado com a contabilidade <b>{{ currentUser.organization.name }}</b>.
    Deseja continuar?
  </p>

</div>
<div mat-dialog-actions class="text-center">
    <div class="container-fluid px-0 py-3 justify-content-between">

      <button class="btn btn-primary text-light mx-2" [disabled]="isConfirming" (click)="goToOttimizza()">
        <i class="fa mr-3" [class]="isConfirming ? 'fa-spinner rotate-constant': 'fa-fingerprint'"></i>Acessar como Ottimizza
      </button>
      <button class="btn btn-primary text-light mx-2" (click)="dialogRef.close()">
        <i class="fa fa-forward mr-3"></i>Continuar
      </button>

    </div>
</div>
